/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-11-21 10:26:16
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-11-27 14:33:13
 */
import React, { ReactNode } from 'react'
import { Modal } from 'antd'
// import user from '../models/user'
const { confirm } = Modal

// confirm
interface confirmProps {
  title: ReactNode
  t1?: any
  onOk?: () => void
  onCancel?: () => void
  okText?: string
  cancelText?: string
}
export const showConfirm = (props: confirmProps) => {
  const {
    title,
    t1,
    onOk = () => null,
    onCancel = () => null,
    okText = '确定',
    cancelText = '取消'
  } = props
  const modal = confirm({
    title: (
      <div className="f-between-start">
        <p>{t1 || '温馨提示'}</p>
        <i
          className="iconfont icon-cha pointer"
          style={{
            color: '#ccc',
            fontSize: 23
          }}
          onClick={() => {
            onCancel()
            modal.destroy()
          }}
        />
      </div>
    ),
    icon: null,
    content: <div style={{ whiteSpace: 'pre-line' }}>{title}</div>,
    okText,
    centered: true,
    width: 520,
    cancelText,
    onOk() {
      onOk()
    },
    onCancel() {
      onCancel()
    }
  })
  return modal
}

// 格式化评论数据
export const changeList = (list: any[]) => {
  const newList: any[] = []
  const childMap = {}
  list.forEach(li => {
    if (li.main_comment_id === 0) {
      newList.push(li)
    } else {
      childMap[li.main_comment_id] = childMap[li.main_comment_id]
        ? [...childMap[li.main_comment_id], li]
        : [li]
    }
  })
  return newList.map(li => ({ ...li, children: childMap[li.id] || [] }))
}

/*
  会议文档模块通用的权限判断方法
  只判断menu的name_en和传入name_en是否匹配
 */

export const verification = (name: string, permissionList: any = []) => {
  if (name === '') {
    return true
  }
  const currentPermission = permissionList.filter(p => p.name_en === name)

  return currentPermission.length > 0
}
